// extracted by mini-css-extract-plugin
module.exports = {"Right":"Register_Right__2Ymw3","Buttons":"Register_Buttons__3720M","ButtonsRight":"Register_ButtonsRight__3jOFX","CheckboxText":"Register_CheckboxText__LejLR"};